/**
 * Model to hold the count of wrestlers for an event
 */
export class ItemCount {
    public id: string;
    public name: string;
    public count: number;

    constructor(id: string, name: string, count: number) {
        this.id = id;
        this.name = name;
        this.count = count;
    }
}

export class DivisionCount extends ItemCount {
    public showRegistrantList: boolean;
    public publishDateTime: Date;
    public weightClasses: ItemCount[] = [];

    constructor(
        id: string,
        name: string,
        count: number,
        showRegistrantList: boolean,
        publishDateTime: Date,
        weightClasses: any[],
    ) {
        super(id, name, count);
        this.showRegistrantList = showRegistrantList;
        this.publishDateTime = publishDateTime;

        if (weightClasses) {
            this.weightClasses = weightClasses.map((wc: any) => new ItemCount(wc.id, wc.name, wc.count));
        }
    }
}

export class ParticipantCount {
    public total: number = 0;
    public divisions: DivisionCount[] = [];

    public getDivisionCount(divisionId: string): number {
        const div: DivisionCount = this.divisions.filter((d: DivisionCount) => d.id === divisionId)[0];
        return (div && div.count) || 0;
    }

    /**
     * Deserialize
     */
    public deserialize(json: Object): ParticipantCount {
        this.total = json['total'];
        const divisions: any[] = json['divisions'] || [];

        for (const div of divisions) {
            this.divisions.push(new DivisionCount(
                div.id,
                div.name,
                div.count,
                div.showRegistrantList,
                div.showRegistrantListDateTime,
                div.weightClasses,
            ));
        }

        return this;
    }
}
